/**
 * The wording of the line under a guest's latest answer (ADR-0083 decision 5,
 * DEV_SPEC-0083 Appendix A.1 / A.2), split around the register link so the
 * caller can build it with textContent. `remaining` is the server's
 * `guest_remaining`; null means the cap is switched off.
 */
export function guestRemainingParts(remaining, registeredCap) {
    const link = 'kostenlosen Konto';
    if (remaining === null || remaining === undefined) {
        return { before: 'Mit einem ', link, after: ' bleiben Ihre Gespräche gespeichert.' };
    }
    if (remaining <= 0) {
        return {
            before: 'Ihre Fragen ohne Anmeldung sind für heute aufgebraucht. Mit einem ',
            link,
            after: ` sind es ${registeredCap} pro Tag.`
        };
    }
    const noun = remaining === 1 ? 'Frage' : 'Fragen';
    return {
        before: `Noch ${remaining} ${noun} heute ohne Anmeldung. Mehr mit einem `,
        link,
        after: '.'
    };
}

// The chat's sentence when a held guest thread has expired (Appendix A.3).
export const EXPIRED_THREAD_TEXT =
    'Dieses Gespräch ist abgelaufen. Ihre Frage steht wieder im Eingabefeld '
    + 'und beginnt ein neues Gespräch.';
